import VueRouter from 'vue-router';
import News from "./components/pages/News/News";
import Settings from "./components/pages/Settings/Settings";
import Login from "./components/pages/Login/Login";
import NotFound from "./components/pages/NotFound";
import Notifications from "@/components/pages/Notifications/Notifications";
import NewsEditor from "@/components/pages/News/NewsEditor";
import NotificationsEditor from "@/components/pages/Notifications/NotificationsEditor";

const routes = [
    { path: '/', name: 'home', component: News, meta: { auth: true, title: 'Новости' } },
    { path: '/news', name: 'news', component: News, meta: { auth: true, title: 'Новости' } },
    { path: '/news/create', name: 'news-create', component: NewsEditor, meta: { auth: true, title: 'Создание новости' } },
    { path: '/news/edit', name: 'news-edit', component: NewsEditor, meta: { auth: true, title: 'Редактирование новости' } },

    { path: '/notifications', name: 'notifications', component: Notifications, meta: { auth: true, title: 'Уведомления' } },
    { path: '/notifications/create', name: 'notifications-create', component: NotificationsEditor, meta: { auth: true, title: 'Создать уведомление' } },

    { path: '/settings', name: 'settings', component: Settings, meta: { auth: true, title: 'Настройки' } },

    { path: '/login', name: 'login', component: Login, meta: { auth: false, strict: true, title: 'Логин' } },

    { path: '*', name: '404', component: NotFound, meta: { auth: false, title: 'Страница не найдена' } }
]

const router = new VueRouter({
    routes,
    mode: 'history',
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;

    const jwt = localStorage.getItem('jwt');
    if (to.meta.auth && !jwt) {
        next({ name: 'login' });
    }

    if (to.meta.strict && jwt) {
        next({ name: 'home' });
    }

    next();
})

export default router;
